var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"subheader":"","two-line":""}},_vm._l((_vm.cragRoute.sections),function(section,index){return _c('div',{key:`crag-route-section-${index}`},[_c('crag-route-section-item-list',{attrs:{"crag-route":_vm.cragRoute,"section":section,"index":index}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }